import type { FC } from 'react';

import {
  Button,
  Typography,
  Icon,
  useDeviceType,
  useKeyboardActions,
} from 'pixel-react';
import { useNavigate, useParams } from 'react-router-dom';

import { SignUpWrapper } from '../SignUpWrapper';
import styles from './ResetLink.module.scss';

export const ResetLink: FC = () => {
  const clientName = import.meta.env.VITE_CLIENT_DETAIL?.name;
  const navigate = useNavigate();
  const { isMobile } = useDeviceType();
  const handleSubmit = async () => {
    navigate('/signin');
  };
  const { email } = useParams();
  useKeyboardActions([
    {
      key: 'Enter',
      action: handleSubmit,
    },
  ]);
  return (
    <SignUpWrapper
      content_header={
        <>
          {' '}
          <Typography fontSize="24px" fontWeight="bold">
            {clientName} AI - Better at being the best
          </Typography>{' '}
        </>
      }
      sub_content={`Using ${clientName}, our customers reap 10x faster scripting, 74% reduction in cost & 54% reduction in maintenance efforts, all at their fingertips`}
      footer_content={`${clientName}: High Speed Testing, Simplified!`}
      copyright_content={`Copyright © ${clientName} Pvt Ltd. All Rights Reserved`}
      className={styles.reset_link_container}
    >
      <section className={styles.form_container}>
        <aside className={styles.reset_link_form}>
          <section className={styles['icon_container']}>
            <Icon
              color=""
              height={isMobile ? 160 : 240}
              width={isMobile ? 160 : 240}
              name="link_reset"
            />
          </section>
          <section className={styles.reset_link_header}>
            <Typography
              fontSize="32px"
              textAlign="center"
              className={styles['header_text']}
            >
              Reset Link sent Successfully !
            </Typography>

            <Typography
              fontSize="16px"
              textAlign="center"
              lineHeight="22px"
              className={styles['sub_header_text']}
            >
              An email has been sent to{' '}
              <Typography
                fontSize="16px"
                textAlign="center"
                lineHeight="22px"
                className={styles['highlighted_text']}
              >
                {window.atob(email || '')}
              </Typography>{' '}
              . Kindly check your inbox for reset link.
            </Typography>
          </section>

          <div className={styles.reset_link_footerbtn}>
            <Button
              type="submit"
              buttonWidth="151px"
              variant="primary"
              onClick={handleSubmit}
            >
              <Typography fontSize="16px" className={styles['register_btn']}>
                Back to Sign In
              </Typography>
            </Button>
          </div>
        </aside>
      </section>
    </SignUpWrapper>
  );
};
